import { globalObject } from "../globalObject/globalObject.js";
import { internalGlobalObjectKey } from "./const.js";
//#region src/sdk/internalFaroGlobalObject.ts
function getInternalFromGlobalObject() {
	return globalObject[internalGlobalObjectKey];
}
function setInternalFaroOnGlobalObject(faro) {
	if (!faro.config.isolate) {
		faro.internalLogger.debug("Registering internal Faro instance on global object");
		Object.defineProperty(globalObject, internalGlobalObjectKey, {
			configurable: false,
			enumerable: false,
			writable: false,
			value: faro
		});
	} else faro.internalLogger.debug("Skipping registering internal Faro instance on global object");
}
function isInternalFaroOnGlobalObject() {
	return internalGlobalObjectKey in globalObject;
}
//#endregion
export { getInternalFromGlobalObject, isInternalFaroOnGlobalObject, setInternalFaroOnGlobalObject };

//# sourceMappingURL=internalFaroGlobalObject.js.map